// Status names only, shared by status.ts and permissions.ts (kept apart so the two can import
// each other's functions without a load-order cycle).

export const PR_STATUSES = [
  'Draft',
  'ProcurementReview',
  'WithDeptHead',
  'Sourcing',
  'PODraft',
  'PendingCFO',
  /** After the CFO, the vertical's PO approver decides (D114). */
  'PendingVertical',
  'POSentPendingCFO',
  'POIssued',
  'PartlyReceived',
  'Received',
  'Invoiced',
  'VoucherWithFinance',
  'Paid',
  'Closed',
  'Returned',
  'Rejected',
  'Cancelled',
  'OnHold',
  /** Procurement buys it with petty cash instead of an RFQ and PO (D65). */
  'PettyCash',
] as const;
export type PrStatus = (typeof PR_STATUSES)[number];

export const TERMINAL: readonly PrStatus[] = ['Closed', 'Rejected', 'Cancelled'];

/** Statuses after the PO went to the supplier and before the request closes. */
export const POST_PO_OPEN: readonly PrStatus[] = [
  'POSentPendingCFO',
  'POIssued',
  'PartlyReceived',
  'Received',
  'Invoiced',
  'VoucherWithFinance',
  'Paid',
];

export type DeliveryState = 'none' | 'partial' | 'full' | 'notRequired';

export const PV_STATUSES = ['Draft', 'WithFinance', 'Returned', 'Received', 'Paid'] as const;
export type PvStatus = (typeof PV_STATUSES)[number];
